export default (theme: Object) => ({
  drawTab: {
    width: 510,
    marginTop: 21,
    [theme.breakpoints.down('xs')]: {
      width: 'auto',
    },
  },
  disclaimer: {
    padding: '0 37px 8px 37px',
    fontSize: 10,
    color: theme.palette.semantic.tooltips,
    lineHeight: '150%',
  },
  dialogActions: {
    marginRight: 20,
    marginBottom: 18,
  },
  actionButtons: {
    marginLeft: 5,
  },
  pads: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pad: {
    marginBottom: 16,
    '&:hover': {
      cursor: 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkuNjA5NTggMy43MzcwNUwyLjEzNTQ2IDExLjIxMTJDMS45OTM4NyAxMS4zNTI4IDEuOTE0MzMgMTEuNTQ0OCAxLjkxNDMzIDExLjc0NUwxLjkxNDMzIDE0Ljk0ODJDMS45MTQzMyAxNS4zNjUyIDIuMjUyMzUgMTUuNzAzMiAyLjY2OTMzIDE1LjcwMzJMNS44NzI1MiAxNS43MDMyQzYuMDcyNzYgMTUuNzAzMiA2LjI2NDggMTUuNjIzNyA2LjQwNjM5IDE1LjQ4MjFMMTMuODgwNSA4LjAwNzk4TDE3LjA4MzcgNC44MDQ3OEMxNy4zNzg1IDQuNTA5OTQgMTcuMzc4NSA0LjAzMTkgMTcuMDgzNyAzLjczNzA1TDEzLjg4MDUgMC41MzM4NTlDMTMuNTg1NyAwLjIzOTAxMyAxMy4xMDc2IDAuMjM5MDE0IDEyLjgxMjggMC41MzM4Nkw5LjYwOTU4IDMuNzM3MDVaTTEwLjE0MzQgNS4zMzg2NUw5LjYwOTU4IDQuODA0NzhDOS4zMTQ3NCA0LjUwOTk0IDkuMzE0NzQgNC4wMzE5IDkuNjA5NTggMy43MzcwNUM5LjkwNDQzIDMuNDQyMjEgMTAuMzgyNSAzLjQ0MjIxIDEwLjY3NzMgMy43MzcwNUwxMS4yMTEyIDQuMjcwOTJMMTMuMzQ2NiAyLjEzNTQ2TDE1LjQ4MjEgNC4yNzA5MkwxMy4zNDY2IDYuNDA2MzhMMTMuODgwNSA2Ljk0MDI1QzE0LjE3NTQgNy4yMzUwOSAxNC4xNzU0IDcuNzEzMTMgMTMuODgwNSA4LjAwNzk4QzEzLjU4NTcgOC4zMDI4MiAxMy4xMDc2IDguMzAyODIgMTIuODEyOCA4LjAwNzk4TDEyLjI3ODkgNy40NzQxMUw1LjU1OTc5IDE0LjE5MzJMMy40MjQzMyAxNC4xOTMyVjEyLjA1NzhMMTAuMTQzNCA1LjMzODY1WiIgLz4KPC9zdmc+Cg==) 5 15, auto', // eslint-disable-line
    },
  },
});
